import { render, staticRenderFns } from "./PLTable.vue?vue&type=template&id=de57e424&scoped=true"
import script from "./PLTable.vue?vue&type=script&lang=js"
export * from "./PLTable.vue?vue&type=script&lang=js"
import style0 from "./PLTable.vue?vue&type=style&index=0&id=de57e424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de57e424",
  null
  
)

export default component.exports